import { render } from "./MultiSelect.vue?vue&type=template&id=ab162c90&scoped=true"
import script from "./MultiSelect.vue?vue&type=script&lang=js"
export * from "./MultiSelect.vue?vue&type=script&lang=js"

import "./MultiSelect.vue?vue&type=style&index=0&id=ab162c90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab162c90"]])

export default __exports__